exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--3GGm2InsJQdTjcm7qy0j9F {\n  display: flex;\n  align-items: flex-start;\n}\n\n.care-team-tasks--3GGm2InsJQdTjcm7qy0j9F:not(:first-child) {\n  margin-top: .4375rem;\n}\n\n.care-team-tasks--3GGm2InsJQdTjcm7qy0j9F label {\n  color: #424242;\n  flex: 1;\n  word-break: break-word;\n}\n\n.care-team-tasks--3Rh8cBYIpZ3Q7vIbaTZSCk label {\n  text-decoration: line-through;\n}\n\n.care-team-tasks--2WIv3ivmxQbERIIz6NpQXZ {\n  margin-left: auto;\n  border: none;\n  outline: none;\n  padding-left: .25rem;\n  line-height: 0;\n  margin-top: 4px;\n}\n\n.care-team-tasks--2WIv3ivmxQbERIIz6NpQXZ:focus {\n  border: none;\n  outline: none;\n}\n", ""]);

// exports
exports.locals = {
	"checklistItem": "care-team-tasks--3GGm2InsJQdTjcm7qy0j9F",
	"checklistItem": "care-team-tasks--3GGm2InsJQdTjcm7qy0j9F",
	"checklistItemCompleted": "care-team-tasks--3Rh8cBYIpZ3Q7vIbaTZSCk",
	"checklistItemCompleted": "care-team-tasks--3Rh8cBYIpZ3Q7vIbaTZSCk",
	"checklistItemDelete": "care-team-tasks--2WIv3ivmxQbERIIz6NpQXZ",
	"checklistItemDelete": "care-team-tasks--2WIv3ivmxQbERIIz6NpQXZ"
};